export enum MarketsTableFields {
  title = 'title',
  description = 'description',
  createdAt = 'createdAt',
  actions = 'actions',
}
